<template>
  <span v-if="emailTemplate"
    >{{ condition.mustBe | ififnot }} consent '{{
      emailTemplate.name.substring(0, 35)
    }}'</span
  >
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  props: ["condition"],
  data() {
    return {};
  },
  methods: {},
  computed: {
    ...mapGetters({}),
    emailTemplate() {
      return this.$store.getters["emailTemplates/emailTemplate"](
        this.condition.templateId
      );
    },
  },
  async mounted() {
    await this.$store.dispatch("emailTemplates/getAll", false);
  },
};
</script>

<style lang="scss">
</style>